import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const PREVIEW_ENGAGEMENT_HANDLER = {
  topic: TOPIC_NAMES.PREVIEW_ENGAGEMENT,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/CrmVizEventPanelWrapper')
};